export default {
    /**
     * Set integrations
     *
     * @param {object} state    Vuex state.
     * @param {object}  data    Array of players objects.
     */
    setIntegrations(state, data) {
        state.integrations = data;
    },
};
